import React from "react";
import NewContact from "../../../components/AddresseePicker/NewContact";
import ContactV2PaginatedDropdown from "components/dropdowns/paginated/ContactV2PaginatedDropdown";

interface Props {
  onContactSelected: (contact: server.dto.ContactSmallV2) => void
  excludedContacts: number[]
}

const AttendeeDropdown = (props: Props) => {
  const onContactCreated = async (contactId: number) => {
    window.CoreApi.Contact.Contact(contactId)
      .then((response) => {
        props.onContactSelected(response.data.data);
      });
  };

  const { canCreate } = site.permissions.addressBook;

  return <div>
    <div className="margin-bottom-mini">
      <ContactV2PaginatedDropdown
        excludeKeys={props.excludedContacts}
        onChange={props.onContactSelected}
        value={null}
        config={{
          isSearchable: true
        }}
      />
    </div>

    {canCreate && <NewContact onContactCreated={onContactCreated} />}
  </div>;
};

export default AttendeeDropdown;